import React, { useEffect, useState } from "react";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Toggle bg + shadow after small scroll
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll(); // initialize on mount
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Pick your scrolled background here:
  const scrolledBg = "bg-white";

  const go = () => {
    const el = document.scrollingElement || document.documentElement;
    const y = Math.max(0, el.scrollHeight - el.clientHeight - 100);
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <nav
      className={[
        "fixed top-0 left-0 w-full z-50 transition-all duration-300",
        scrolled || open
          ? `${scrolledBg} shadow-[0_2px_12px_rgba(0,0,0,0.08)]`
          : "bg-transparent shadow-none",
      ].join(" ")}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="h-[88px] flex items-center justify-between">
          {/* Left: Logo */}
          <a href="/">
            <img
              src="./fclogo.png"
              alt="Fconnect logo"
              className="h-[60px] w-auto"
            />
          </a>

          {/* Right: Desktop Buttons */}
          <div className="hidden md:flex items-center gap-4 cursor-pointer">
            <a
              onClick={go}
              className="text-lg font-medium leading-[100%] text-[#06382f]"
            >
              Get Started
            </a>
            <a
              href="https://partner.footylight.com/login"
              target="_blank"
              className="rounded-full px-5 py-3 text-base font-medium text-white bg-[#06382f] leading-[100%]"
            >
              Client Login
            </a>
          </div>

          {/* Right: Mobile Hamburger */}
          <button
            aria-label="Toggle menu"
            aria-expanded={open}
            onClick={() => setOpen(!open)}
            className={`md:hidden inline-flex items-center justify-center rounded-md p-2  ${
              scrolled || open ? "text-[#06382f]" : "text-[#06382f]"
            }`}
          >
            {open ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-7"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-7"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile full-width dropdown */}
      <div
        className={`md:hidden w-full transition-all duration-300 ease-in-out ${
          open ? "max-h-96 opacity-100" : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        <div className="w-full bg-white px-6 py-6 flex flex-col gap-4 text-[#06382f]">
          <a
            className="text-base w-full"
            onClick={() => {
              go();
              setOpen(false);
            }}
          >
            Get Started
          </a>
          <a
            href="https://partner.footylight.com/login"
            target="_blank"
            onClick={() => setOpen(false)}
            className="mt-2 w-full max-w-[300px] rounded-md py-3 text-sm font-semibold text-white bg-[#005c66] cursor-pointer flex self-center justify-center"
          >
            Client Login
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
